import React, {useMemo, useState} from "react";
import {DefaultPageProps} from "@models/DefaultProps.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {ButtonGroup, Grid} from "@mui/material";
import {RecursoContaContabilLimiteEntry} from "@components/recurso/RecursoContaContabilLimiteEntry.tsx";
import {ContasContabeisPage} from "@components/contaContabil/pages/ContasContabeisPage.tsx";
import {fullHeight} from "@models/helpers.ts";
import {CcFiltersPage} from "@components/contaContabil/CcFiltersPage.tsx";
import {IContasContabeisFiltroDto} from "@models/contaContabil/createContaContabilDto.ts";
import {SearchTextField} from "@components/shared/textField/SearchTextField.tsx";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {PermissionableButton} from "@shared/specialComponents/PermissionableButton.tsx";
import {ContaContabilCadastraPage} from "@components/contaContabil/pages/ContaContabilCadastraPage.tsx";

interface RecursoContaContabilLimitePageProps extends DefaultPageProps {
    recursoId: number;
}

export function RecursoContaContabilLimitePage(props: RecursoContaContabilLimitePageProps) {
    const {addPopUp, closePopUp} = useAlert()

    const [filters, setFilters] = useState<IContasContabeisFiltroDto>(props.recursoId ? {idRecurso: [props.recursoId]} : {});
    const [filtros, setFiltros] = useState<IContasContabeisFiltroDto>(filters);
    const [pagination, setPagination] = useState<IPagination>({page: 1, pageSize: 10});

    const filtersPage = useMemo(() => {
        return (<CcFiltersPage filtros={filters} setFiltros={setFilters} onApply={() => {
            setFiltros(filters)
            closePopUp()
        }}/>)
    }, [filters]);


    return (
        <DefaultContainer titulo={props.hideHeader ? '' : 'Limites por Conta Contábil'}
                          UpperComponent={<Grid container
                                                justifyContent={'space-between'}>
                              <Grid>
                                  <SearchTextField value={filters.search}
                                                   onChange={(v) => setFilters({...filters, search: v.target.value})}
                                                   label={'Pesquisa de conta contabil'}
                                                   onSearch={() => {
                                                       setFiltros(filters)
                                                       closePopUp()
                                                   }} openFilters={() => {
                                      addPopUp({title: 'Filtros', content: filtersPage, size: 'lg'})
                                  }}
                                  />
                              </Grid>

                              <Grid>
                                  <ButtonGroup sx={{...fullHeight}} size={'small'}>
                                      <PermissionableButton permission={['CriarContaContabil']}
                                                            onClick={() => {
                                                                addPopUp({
                                                                    title: 'Criando nova conta contábil',
                                                                    content: <ContaContabilCadastraPage
                                                                        onCreate={() => {
                                                                            setPagination(prev => ({...prev, page: 0}))
                                                                            closePopUp()
                                                                        }} hideHeader/>,
                                                                    size: 'lg',

                                                                })
                                                            }}
                                                            label={'Criar conta contabil'}/>
                                      <PermissionableButton permission={['CriarContaContabil']}
                                                            label={'Importar'}/>
                                  </ButtonGroup>
                              </Grid>
                          </Grid>}>
            <ContasContabeisPage hideHeader
                                 pageProps={{pagination, setPagination}}
                                 filtros={filtros}
                                 searchType={'LimitesRecurso'}
                                 slotProps={{
                                     ContaContabilItem: {
                                         EndComponent: (c) => <RecursoContaContabilLimiteEntry
                                             key={c.id}
                                             recursoId={props.recursoId}
                                             contaContabilId={c.id}
                                             limiteInitial={c.recursoLimites?.find(x => x.recursoId == props.recursoId)}
                                             onSendLimite={() => {
                                             }}
                                             solicitacoes={c.solicitacoes?.filter(x => x.recursoId == props.recursoId)}
                                         />,
                                     },
                                 }}
            />
        </DefaultContainer>
    );
};